import { Button } from "@omni/ui/components/Button/button.component";
import classnames from "classnames";

import { CustomerOrderModel } from "@/api/mappers/customerOrderList.mapper";
import OrderItem from "@/components/Account/OrderList/Order/OrderItem/orderItem.component";
import { Divider } from "@/components/General/Divider/divider.component";
import { Container } from "@/components/General/Grid/container.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import "./order.scss";

type Props = {
    setActive: (id: string | null) => void;
    activeId: string | null;
    orderId: string;
    order: CustomerOrderModel;
};

const Order = ({ setActive, activeId, orderId, order }: Props) => {
    const { t } = useGranite();
    const onlyFirst = activeId !== orderId;
    const validItems = order.items.filter(
        (item) =>
            item.title !== null &&
            !item.warrantyDeposit &&
            !item.isAdditionalService
    );

    return (
        <Container>
            {validItems
                .slice(0, onlyFirst ? 1 : validItems.length)
                .map((item, index) => (
                    <OrderItem
                        key={`${item.sku}-${orderId}`}
                        item={item}
                        index={index}
                        orderId={orderId}
                    />
                ))}
            {validItems.length > 1 && (
                <>
                    <Divider
                        marginTop="0"
                        className={"my-2 mt-sm-0"}
                    />
                    <Row>
                        <div className="col text-right">
                            <Button
                                test="order-button-toggle"
                                type="button"
                                className={"text-decoration-none px-0 pt-0"}
                                color="link"
                                onClick={() =>
                                    setActive(onlyFirst ? orderId : null)
                                }
                            >
                                <span className={"pr-2"}>
                                    {t(
                                        `general.${
                                            onlyFirst ? "open" : "close"
                                        }`
                                    )}
                                </span>
                                <i
                                    className={classnames(
                                        "orderList-order__icon",
                                        `las la-chevron-circle-${
                                            onlyFirst ? "down" : "up"
                                        }`
                                    )}
                                />
                            </Button>
                        </div>
                    </Row>
                </>
            )}
        </Container>
    );
};

export default Order;
